ACC.cartremoveitem = {

	bindAll: function ()
	{
		this.bindCartRemoveProduct();
	},
	bindCartRemoveProduct: function ()
	{
		// TODO: please DRY me! 

		$('.submitRemoveProduct').on("click dblclick", function (event)
		{
			
			// Avoid remove double clicks HWM-909
			$(".submitRemoveProduct").hide();
			$(this).closest('tr').fadeTo( "slow" , 0, function() {});

			// fix for unique ids
			var prodid = $(this).attr('id').split("_")[1];
			var productCode = $('#updateCartForm' + prodid).get(0).productCode.value;
			var initialCartQuantity = $('#updateCartForm' + prodid).get(0).initialQuantity.value;

			if (window.trackRemoveFromCart)
			{
				trackRemoveFromCart(productCode, initialCartQuantity);
			}

			if($('#updateCartForm' + prodid).get(0).isGiftBoxProduct.value) {
				$('#updateCartForm' + prodid).get(0).quantity.disabled = false;
			}

			$('#updateCartForm' + prodid).get(0).quantity.value = 0;
			$('#updateCartForm' + prodid).get(0).initialQuantity.value = 0;
			$('#updateCartForm' + prodid).get(0).submit();
			
		});

		
		$("body").on("click",".updateQuantityProduct.notyetclicked", function(e) {

			var stopClick = 0; // new timestamp given
			$('.updateQuantityProduct').removeClass("notyetclicked");
			
			if(e.timeStamp - stopClick > 1000) { // give 300ms gap between clicks
			// fix for unique ids
			var prodid = $(this).attr('id').split("_")
			prodid = prodid[1];


			var productCode = $('#updateCartForm' + prodid).get(0).productCode.value;
			var initialCartQuantity = $('#updateCartForm' + prodid).get(0).initialQuantity.value;
			var newCartQuantity = $('#updateCartForm' + prodid).get(0).quantity.value;

			if (window.trackUpdateCart)
			{
				trackUpdateCart(productCode, initialCartQuantity, newCartQuantity);
			}

			$('#updateCartForm' + prodid).get(0).submit();
			
			
			stopClick = e.timeStamp; // new timestamp given
			return false;
			}

		});
		
		$("body").on("click",".updateQuantityProduct", function(e) {
				
				return false;

			});
	}
}

$(document).ready(function ()
{
	ACC.cartremoveitem.bindAll();
});
